import $api from "../api";

export const state = {
    stats: {
        total_banded: 0,
        total_chapters: 0,
        total_farms: 0,
        total_stag_registry: 0,
        total_breeders: 0,
        total_admin_users: 0,
        total_encoder_users: 0,
        total_viewer_users: 0,
    },
};

export const actions = {
    getStats({ commit, rootGetters }) {
        return new Promise(function (resolve) {
            $api
                .get('summary/statistics', {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200) {
                        commit("setStats", res.data.data);
                        resolve(res.data.data);
                    }
                })
                .catch(function () {
                    resolve(null);
                });
        });
    },
};

export const mutations = {
    setStats(state, data) {
        if (!data) return;
        state.stats.total_banded = data.total_banded || 0;
        state.stats.total_chapters = data.total_chapters || 0;
        state.stats.total_farms = data.total_farms || 0;
        state.stats.total_stag_registry = data.total_stag_registry || 0;
        state.stats.total_breeders = data.total_breeders || 0;
        state.stats.total_admin_users = data.total_admin_users || 0;
        state.stats.total_encoder_users = data.total_encoder_users || 0;
        state.stats.total_viewer_users = data.total_viewer_users || 0;
    },
};

export const getters = {
    stats: (state) => state.stats,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
